export const EngineTypes = {
  TWO_STROKE_ENGINE: 'two_stroke_engine',
  FOUR_STROKE_ENGINE: 'four_stroke_engine',
} as const;

export type EngineType = (typeof EngineTypes)[keyof typeof EngineTypes];
